export enum RestoreSessionStatus {
    Running = 0,
    Stopped = 1
}
